// utils/playerSession.js
const STORAGE_KEY = "selectedTeamPlayers";
const MATCH_KEY = "selectedMatch";
const MY_TEAM_KEY = "myTeam";


export const groupPlayersByMatch = (players) => {
  return players.reduce((acc, player) => {
    if (!acc[player.matchId]) {
      acc[player.matchId] = [];
    }
    acc[player.matchId].push(player);
    return acc;
  }, {});
};

export const savePlayersToSession = (players) => {
  const grouped = groupPlayersByMatch(players);
  sessionStorage.setItem("matchPlayers", JSON.stringify(grouped));
};

export const saveMatchPlayers = (matchId, players) => {
  const existing = sessionStorage.getItem("matchPlayers");
  const parsed = existing ? JSON.parse(existing) : {};

  parsed[matchId] = players;

  sessionStorage.setItem("matchPlayers", JSON.stringify(parsed));
};


export const getPlayersByMatch = (matchId) => {
  const data = sessionStorage.getItem("matchPlayers");

  if (!data) return [];

  const parsed = JSON.parse(data);
  return parsed[matchId] || [];
};

//save and get saved players in session storage
export const saveSelectedTeamPlayers = (players) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(players));
};

export const getSelectedTeamPlayers = () => {
  try {
    const data = sessionStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error("Session parse error:", error);
    return [];
  }
};
//save and get my Team in session storage
export const saveMyTeam = (team) => {
  sessionStorage.setItem(MY_TEAM_KEY, JSON.stringify(team));
};

export const getMyTeam = () => {
  try {
    const data = sessionStorage.getItem(MY_TEAM_KEY);
    return data ? JSON.parse(data) : [];
  } catch (error) {
    console.error("Session parse error:", error);
    return [];
  }
};

//save and get matchdetails in session storage
export const saveSelectedMatch = (match) => {
  if (!match) return;
  sessionStorage.setItem(MATCH_KEY, JSON.stringify(match));
};

export const getSelectedMatch = () => {
  try {
    const data = sessionStorage.getItem(MATCH_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Invalid match session data");
    return null;
  }
};

export const clearSelectedMatch = () => {
  sessionStorage.removeItem(MATCH_KEY);
};
